import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { styled } from 'styled-components';
import { S as ns } from '../SignUP/NewSingUp.style';
import LoginSerivce from '../../service/login/login';
import { useUser } from '../../context/UserContext';
import SocialLogin from '../components/login/SocialLogin';
import { PageContainer } from '../components/common/PageComponent.style';
import PageTop from '../components/pageTop/PageTop';

const Login = () => {
  const { setUser } = useUser();
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [idSave, setIdSave] = useState(false);
  const navigate = useNavigate();
  const { setIsLoggedIn } = useAuth();
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isIdValid, setIsIdValid] = useState(true);
  const [loginError, setLoginError] = useState(
    '아이디 혹은 비밀번호가 일치하지 않습니다.',
  );
  const isLoginEnabled = true;
  // const Logo = '/assets/images/logo/zipgoai_logo_login.svg';
  const LoginApi = async () => {
    try {
      if (id.trim() === '' || password.trim() === '') {
        setIsIdValid(false);
        setLoginError('아이디와 비밀번호를 입력해주세요.');
        return;
      }

      const result = await LoginSerivce.login({
        userid: id,
        password: password,
      });
      if (result.status === 'success') {
        if (idSave) {
          localStorage.setItem('id', id);
        }
        localStorage.setItem('accessToken', result.data.accessToken);
        localStorage.setItem('userType', result.data.user.usertype);
        localStorage.setItem('userName', result.data.user.name);
        localStorage.setItem('plan_end', result.data.user.plan_end);
        localStorage.setItem(
          'recommend_code',
          result.data.user.recommend_code ?? '', // null이면 빈 문자열로 저장
        );
        setIsLoggedIn(true);
        setUser(result.data.user);

        navigate('/', { replace: true, state: { index: 0 } });
      }
    } catch (error: any) {
      setIsIdValid(false);
      setLoginError(
        error.response.data.message.includes('탈퇴')
          ? error.response.data.message
          : '아이디 혹은 비밀번호가 일치하지 않습니다.',
      );
      error.response.data.message.includes('인증') &&
        alert(`${error.response.data.message}\n인증 후 연락드리겠습니다.`);
    }
  };

  // 페이지가 처음 로드될 때 로컬 스토리지에서 id 값을 가져옵니다.
  useEffect(() => {
    const storedId = localStorage.getItem('id');
    const urlParams = new URLSearchParams(window.location.search);
    const error = urlParams.get('error');
    if (error) {
      alert(error);
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    if (storedId) {
      setId(storedId); // 로컬스토리지에 값이 있다면 id 상태로 설정
      setIdSave(true);
    }
  }, []); // 빈 배열을 주면 컴포넌트 마운트 시에만 실행됩니다.

  return (
    <PageContainer>
      <PageTop hasButton={false} />
      <Inner>
        <LogoContainer>
          <Logo
            src="/assets/images/logo/zipgoai_logo_login.svg"
            alt="logo"
            onClick={() => navigate('/')}
          />
        </LogoContainer>
        <LoginContainer>
          <SNSLoginSection>
            <SocialLogin />

            <DividerWrapper>
              <Divider />
              <DividerLabel>or</DividerLabel>
              <Divider />
            </DividerWrapper>
          </SNSLoginSection>
          <IDLoginSection>
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                LoginApi();
              }}
            >
              <InputWrapper>
                <LoginInput
                  value={id}
                  placeholder="아이디를 입력해주세요."
                  onChange={(e: any) => {
                    setId(e.target.value);
                  }}
                />

                <InputGroup>
                  <LoginInput
                    placeholder="비밀번호를 입력해주세요."
                    onChange={(e: any) => {
                      setPassword(e.target.value);
                    }}
                    security="true"
                    type={passwordVisible ? 'text' : 'password'}
                  />
                  <VisibleButton>
                    <img
                      onClick={() => {
                        setPasswordVisible((prev) => !prev);
                      }}
                      src={`/assets/images/icon/${passwordVisible ? 'Visible_icon' : 'notVisible_icon'}.svg`}
                      alt=""
                    />
                  </VisibleButton>
                  {!isIdValid && (
                    <Feedback>
                      <img
                        src={`/assets/images/icon/${'signUpInfo_icon_NotValid'}.svg`}
                        alt=""
                      />
                      {loginError}
                    </Feedback>
                  )}
                </InputGroup>

                <LoginOptionContainer>
                  <IdSaveButton
                    onClick={() => {
                      setIdSave((prev) => !prev);
                    }}
                  >
                    <img
                      style={{ width: '20px', height: '20px' }}
                      src={
                        idSave
                          ? 'assets/images/check/idSaveOn.svg'
                          : 'assets/images/check/idSaveOff.svg'
                      }
                      alt=""
                    />
                    <LoginOptionButton>아이디 저장</LoginOptionButton>
                  </IdSaveButton>

                  <LoginOptionButton>
                    <div
                      onClick={() => {
                        navigate('/find', { state: { type: 'id' } });
                      }}
                    >
                      아이디&nbsp;
                    </div>
                    <div> ∙&nbsp;</div>
                    <div
                      onClick={() => {
                        navigate('/find', {
                          state: { type: 'password' },
                        });
                      }}
                    >
                      비밀번호 찾기
                    </div>
                  </LoginOptionButton>
                </LoginOptionContainer>
              </InputWrapper>
              <LoginButton
                type="submit"
                disabled={!isLoginEnabled}
                $enable={isLoginEnabled}
                onClick={() => {
                  LoginApi();
                }}
              >
                로그인
              </LoginButton>
            </Form>
            <SignupSection>
              아직 땅집고옥션 회원이 아니신가요?
              <SignupButton
                onClick={() => {
                  navigate('/signUp');
                }}
              >
                회원가입
              </SignupButton>
            </SignupSection>
          </IDLoginSection>
        </LoginContainer>
      </Inner>
    </PageContainer>
  );
};

export default Login;

const Inner = styled.div`
  padding: 60px 16px 120px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 42px;
  align-self: stretch;
  flex: 1 0 0;
  background: #fff;
`;

const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

const Logo = styled.img`
  cursor: pointer;
`;

const LoginContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const SNSLoginSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const DividerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background: rgba(112, 115, 124, 0.22);
`;

const DividerLabel = styled.div`
  color: rgba(55, 56, 60, 0.61);
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
`;

const IDLoginSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const InputGroup = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const LoginInput = styled.input`
  display: flex;
  height: 50px;
  padding: 4px 16px;
  align-items: center;
  align-self: stretch;

  border-radius: 8px;
  border: 1px solid #e5e8ea;
  background: #f7f8fc;

  color: #222;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;

  &::placeholder {
    color: #0019364f;
  }

  &:focus {
    outline: none;
    border: 1px solid #008aff;
  }
`;

const VisibleButton = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
  img {
    width: 20px;
    height: 20px;
  }
`;

const Feedback = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  align-self: stretch;

  color: #fc2b4f;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const LoginOptionContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
`;

const IdSaveButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const LoginOptionButton = styled.div`
  display: flex;
  flex-direction: row;

  color: #616161;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;

  cursor: pointer;
`;

const LoginButton = styled.button<{ $enable?: boolean }>`
  display: flex;
  padding: 14px 28px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 8px;
  border: none;
  outline: none;

  background: ${({ $enable }) => ($enable ? '#007AFF' : '#F7F7F8')};
  color: ${({ $enable }) => ($enable ? '#fff' : '#37383C29')};
  cursor: ${({ $enable }) => ($enable ? 'pointer' : 'default')};

  text-align: center;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const SignupSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  align-self: stretch;

  color: #616161;
  font-size: 14px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.28px;
`;

const SignupButton = styled.div`
  cursor: pointer;
  color: #222;
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.28px;
`;
